module.exports = __webpack_public_path__ + "img/0-2.bcbe1ec6.gif";